import { MainStyles } from '@genesislcap/foundation-header';
import { css } from '@microsoft/fast-element';
import { scrollbarStyles } from '../../../../styles';

export const LinkAdvisorsCellStyles = css`
  .icon-cells {
    vertical-align: middle;
    text-align: center;
  }

  td {
    vertical-align: middle;
    padding: 2px 2px 2px 2px;
    border-bottom: 1px solid #797979;
    box-sizing: border-box;
    line-height: normal;
    color: #c9c9c9;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    font-size: 13px;
  }

  th {
    border-bottom: 1px solid #879ba6;
    box-sizing: border-box;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
    color: #879ba6;
    text-align: left;
    line-height: normal;
  }
`;

export const LinkAdvisorsStyles = css`
  ${scrollbarStyles}

  fast-dialog.default-dialog::part(control) {
    --dialog-height: none;
    --dialog-width: none;
    border-radius: 6px;
    border: 1px solid #2e3339;
    background-color: #1c2024;
    box-sizing: border-box;
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.35);
    position: relative;
    padding: 28px;
  }

  .disabled {
    pointer-events: none;
  }

  .disabled-table {
    cursor: not-allowed;
  }

  .card-title {
    font-weight: 700;
    color: #ffffff;
    text-align: left;
    line-height: normal;
    padding: 16px 32px 11px 18px;
  }

  .company-card {
    width: 267px;
    height: 680px;
    padding: 2px 2px 2px 2px;
    border-radius: 6px;
    border: 1px solid #2e3339;
    background-color: #202328;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .users-card {
    width: 560px;
    height: 680px;
    padding: 2px 2px 2px 2px;
    border-radius: 6px;
    border: 1px solid #2e3339;
    background-color: #202328;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .dialog-header {
    height: 56px;
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dialog-body {
    display: flex;
  }

  .dialog-footer {
    display: flex;
    flex-direction: row-reverse;
    padding-top: 28px;
  }

  .next-step-icon {
    display: flex;
    height: inherit;
    padding: 16px;
    align-items: center;
  }

  .title {
    color: #fff;
    text-align: center;
    line-height: normal;
    font-size: x-large;
    font-weight: bold;
    position: absolute;
    top: 22px;
  }

  .search-bar {
    padding: 0 16px;
    width: -webkit-fill-available;
  }

  .closing-icon {
    background: transparent;
    border: none;
    height: 32px;
    margin: 0;
    min-width: 32px;
    position: absolute;
    right: 15px;
    top: 12px;
  }

  .closing-icon:hover {
    background: var(--button-hover-bg);
  }

  .closing-icon::part(control):focus-visible {
    border: none;
    box-shadow: none;
  }

  .closing-icon:hover svg path {
    fill: var(--white);
  }

  .table-container {
    margin-top: 20px;
    overflow: auto;
  }

  .grid {
    border-spacing: 0;
    width: 100%;
    height: 100%;
  }

  .header-row {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: rgb(32, 35, 40);
  }

  .radio-cell {
    width: 50px;
  }

  .info-cell {
    width: 37px;
  }

  .name-header {
    min-width: 174px;
    padding: 0px 12px 8px 0;
  }

  ${LinkAdvisorsCellStyles}
`;
